<template>
    <div className="m-vue-pdf">
        <div v-show="loaded">
            <Pdf v-for="index in numPages" :key="index" :src="pdfUrl1" :page="index"/>
        </div>
    </div>
</template>
<script>
import Pdf from 'vue-pdf'

export default {
    name: 'VuePdf',
    components: {
        Pdf
    },
    props: {
        pdfUrl: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loaded: false,
            numPages: null,
            pdfUrl1: this.pdfUrl
        }
    },
    created() {
        this.loadPdf()
    },
    methods: {
        // 上下滚动pdf加载
        loadPdf() {
            this.pdfUrl1 = Pdf.createLoadingTask(this.pdfUrl1)
            this.pdfUrl1.promise.then(pdf => {
                this.$nextTick(() => {
                    this.numPages = pdf.numPages // pdf总页数
                    this.loaded = true
                })
            })
        }
    }
}
</script>
<style lang="less" scoped>
.m-vue-pdf {
  overflow: hidden;
}
</style>
